import Icon from '__core/modules/atoms/Icons';
import clsx from 'clsx';
import React from 'react';
import { Toaster, toast as sonnerToast } from 'sonner';

/**
 * Toast Provider wrapper usando Sonner
 * Aislado para facilitar cambios futuros de librería
 */
export function ToastProvider({ children }) {
  return (
    <>
      {children}
      <Toaster
        position="bottom-left"
        duration={8000}
        closeButton={false}
        toastOptions={{
          unstyled: true,
          classNames: {
            toast: 'toast-wrapper',
          },
        }}
      />
    </>
  );
}

/**
 * Componente visual personalizado para los toasts
 */
function ToastComponent({ appearance, message, onClose, isList }) {
  function getIcon() {
    if (appearance === 'info') return 'icon-toast-info';
    if (appearance === 'success') return 'icon-toast-success';
    if (appearance === 'warning') return 'icon-toast-warning';
    if (appearance === 'error') return 'icon-toast-error';
    return 'icon-toast-info';
  }

  return (
    <div className={clsx({ 'toast--list': isList })}>
      <div
        className={clsx('toast', {
          'toast--info': appearance === 'info',
          'toast--success': appearance === 'success',
          'toast--warning': appearance === 'warning',
          'toast--error': appearance === 'error',
        })}
      >
        <div className="d-flex align-items-center">
          <Icon type={getIcon()} />
          <div className="ml-2">{message}</div>
        </div>

        <button
          type="button"
          className="d-flex align-items-center hover-basic ml-3"
          onClick={onClose}
          aria-label="Cerrar notificación"
          style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
        >
          <Icon type="icon-close" />
        </button>
      </div>
    </div>
  );
}

/**
 * API wrapper sobre sonner para mantener consistencia
 * Permite cambiar la implementación sin afectar el código que usa toasts
 */
export const toastAPI = {
  show: (message, options = {}) => {
    const { appearance = 'success', duration = 8000, isList = false } = options;

    const toastId = sonnerToast.custom((t) => <ToastComponent appearance={appearance} message={message} onClose={() => sonnerToast.dismiss(t)} isList={isList} />, {
      duration,
    });

    return toastId;
  },

  success: (message, options = {}) => {
    return toastAPI.show(message, { ...options, appearance: 'success' });
  },

  error: (message, options = {}) => {
    return toastAPI.show(message, { ...options, appearance: 'error' });
  },

  warning: (message, options = {}) => {
    return toastAPI.show(message, { ...options, appearance: 'warning' });
  },

  info: (message, options = {}) => {
    return toastAPI.show(message, { ...options, appearance: 'info' });
  },

  dismiss: (toastId) => {
    if (toastId) {
      sonnerToast.dismiss(toastId);
    } else {
      sonnerToast.dismiss();
    }
  },
};
